import React, { FC } from 'react';
import { Avatar, Typography, Link, Stack } from '@mui/material';
import { FormPublicDesignFragment } from 'graphql/fragment/form.public.fragment';

interface Props {
  name: string;
  position: string;
  email: string;
  picture: string;
  design: FormPublicDesignFragment;
}

const Supporter: FC<Props> = ({ name, position, email, picture, design }) => {
  return (
    <Stack>
      <Avatar
        alt={name}
        src={picture}
        sx={{
          width: 100,
          height: 100,
          alignSelf: 'center',
          marginBottom: '10px',
        }}
      />
      <Typography color='white' align='center' fontWeight='bold'>
        {name}
      </Typography>
      <Typography
        color='white'
        sx={{ whiteSpace: 'pre-line', fontSize: '0.9rem' }}
        align='center'
      >
        {`${position}\n`}
        <Link
          href={`mailto:${email}`}
          underline='hover'
          sx={{
            color: 'white',
            transition: `color 0.25s ease-in`,
            ':hover': { color: design.colors.button },
          }}
        >
          {email}
        </Link>
      </Typography>
    </Stack>
  );
};

export default Supporter;
